export enum Page {
  DEFAULT_PAGE_SIZE = 14,
  DEFAULT_PAGE_NUMBER = 0
}
